import {CommandRequester} from '../../../CommandRequester';
import {MotionToken, Motion} from './requesters/Motion';
import {HeadTouchToken, HeadTouch} from './requesters/HeadTouch';
import {FaceTrackToken, FaceTrack} from './requesters/FaceTrack';

/**
 * Commands for working with Jibo's sensory input
 * @namespace CommandRequester.perception
 */
export class Perception{

    /**
     * Commands for subcribing to perception events
     * @namespace CommandRequester.perception.subscribe
     */
    public subscribe;

    constructor(requester:CommandRequester) {
        this.subscribe = new Subscriptions(requester);
    }
}

export class Subscriptions {

    private motionRequest:Motion;
    private headTouchRequest:HeadTouch;
    private faceTrackRequest:FaceTrack;

    constructor(requester: CommandRequester) {
        this.motionRequest = new Motion(requester);
        this.headTouchRequest = new HeadTouch(requester);
        this.faceTrackRequest = new FaceTrack(requester);
    }
    
    /**
     * @method CommandRequester.perception.subscribe#headTouch
     * @description Listen for head touch.
     * @return {HeadTouchToken}
     */
    public headTouch(): HeadTouchToken {
        const protocol = HeadTouch.generateProtocol();
        return this.headTouchRequest.generateToken(protocol, true);
    }

    /**
     * Subcribe to motion events in Jibo's field of vision
     * @method CommandRequester.perception.subscribe#motion
     * @return {MotionToken}
     */
    public motion(): MotionToken {
        const protocol = Motion.generateProtocol();
        return this.motionRequest.generateToken(protocol, true);
    }

    /**
     * Subscribe to face-finding events in Jibo's field of vision
     * @method CommandRequester.perception.subscribe#face
     * @return {FaceTrackToken}
     */
    public face(): FaceTrackToken {
        const protocol = FaceTrack.generateProtocol();
        return this.faceTrackRequest.generateToken(protocol, true);
    }
}